// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Resize from './4-resize.js';

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------
export const canvasEl = document.getElementById('canvas');
let ctx;
if (canvasEl) ctx = canvasEl.getContext('2d');
// const staticInterval = 10000;
// console.log({canvasEl, ctx}, canvasEl.width);

// once function --------------------------------------------------------------
export const initStatic = () => {
  // console.log('initStatic');
  // set canvas size

  // setInterval(drawStatic, staticInterval);
  // setCanvasSize();
};

const drawStatic = () => {
  // console.log('drawStatic');
  // generate grey pixels
  const imageData = ctx.createImageData(canvasEl.width, canvasEl.height);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    // const grey = 255 -Math.floor(Math.random() * 20);
    const grey = 127 - Math.floor(Math.random() * 128);
    // const grey = Math.floor(Math.random() * 255);
    data[i] = grey;     // Red
    data[i + 1] = grey; // Green
    data[i + 2] = grey; // Blue
    data[i + 3] = 255;  // Alpha
  }

  ctx.putImageData(imageData, 0, 0);
};

export const setCanvasSize = () => {
  // console.log('setCanvasSize');
  let willDraw = false;

  const canvasWidth = canvasEl.width;
  const width = Math.round(Resize.windowWidth / 1.5);
  // console.log({canvasWidth, width});
  if (canvasWidth != width) {
    canvasEl.width = width;
    willDraw = true;
  }

  const canvasHeight = canvasEl.height;
  const height = Math.round(Resize.documentHeight / 1.5);
  // console.log({canvasHeight, height});
  if (canvasHeight < height) {
    canvasEl.height = height
    willDraw = true;
  }

  // only draw again is width change or height became more
  if (willDraw) drawStatic();
}
